import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import AttachmentControlVM from './control';
import './cancel.html';

export interface AttachmentCancelControlVMConfig {
    click: Action
}

@injectable()
export default class AttachmentCancelControlVM extends AttachmentControlVM {
    private clickHandler: Action

    constructor(
        @inject(wccModules.componentConfig) config: AttachmentCancelControlVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        super(info);

        this.clickHandler = config.click;
    }

    click() {
        this.clickHandler();
    }
}